import useSetExport from '@components/export/useSetExport';
import { useMemo } from 'react';

function useSetManualAlertExport(info) {

  const data = useMemo(() => {
    if (info) {
      const {
        name,
        metric,
        timeRange,
        cooldown,
        priority,
        rule,
        threshold,
      } = info;
      const data = [
        ['Alert Name', name],
        [metric, rule],
        ['Audience Threshold', threshold],
        ['Start Time - End Time', timeRange],
        ['Cool Down Period', cooldown],
        ['Priority', priority],
      ];

      return data;
    }
    return null;
  }, [info]);

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'alerts-panel',
    widgetKey: 'manual-alert-summary',
    widgetInfo: { title: 'Manual Alert Summary' },
    data,
    headers: [{ title: '', key: 'field' }, { title: '', key: 'value' }],
  });

}

export default useSetManualAlertExport;
